import React, { useState, useEffect } from "react"
import { Table, Button, Tooltip } from "antd"
import { EditOutlined } from "@ant-design/icons"
import SetIndicatorGoalModal from "./SetIndicatorGoalModal"
import CommonConstants from "../../CommonConstants"
import {
  getMergedDataWithKeysforNew,
  getMergedDataWithKeysforOld,
} from "../../utilities"
import commonStrings from "../../commonStrings"
import path from "../../../assets/images/Path.png"
import Frame from "../../../assets/images/Frame5085.png"
import tickCircle from "../../../assets/images/tick-circle.png"
import componentStyles from "../../styles"

const IndicatorTable = ({
  tableData,
  upsertGoals,
  onUpdatedTableData,
  tableListing,
  disableOnTenureCompletion,
  rubric,
  tableListingold,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedIndicator, setSelectedIndicator] = useState(null)
  const handleEditClick = (record) => {
    setSelectedIndicator({
      implementation_rubric_indicator_id: record.indicator_id,
      value: record.goal === 0 ? 0 : record.goal || null,
      target_completion_date: record.goal_date,
    })
    setIsModalVisible(true)
  }
  const handleCloseModal = () => {
    setIsModalVisible(false)
    setSelectedIndicator(null)
  }
  const mergedData = getMergedDataWithKeysforNew(tableListing)
  const mergedDataold = getMergedDataWithKeysforOld(tableListingold)
  const [showInitialValueColumn, setShowInitialValueColumn] = useState(false)
  const [showPreviousRatingColumn, setShowPreviousRatingColumn] = useState(false)
  const [showStatusgColumn, setStatusColumn] = useState(false)
  useEffect(() => {
    if (rubric && rubric.created_at) {
      const rubricDate = new Date(rubric.created_at)
      const today = new Date()
      const getTenureYear = (date) => {
        const year = date.getMonth() >= 7 ? date.getFullYear() : date.getFullYear() - 1
        const start = new Date(`${year}-08-01T00:00:00`)
        const end = new Date(`${year + 1}-07-31T23:59:59`)
        return { start, end, year }
      }

      const currentTenureYear = getTenureYear(today)
      const isCurrentTenure = rubricDate >= currentTenureYear.start
        && rubricDate <= currentTenureYear.end
      setShowInitialValueColumn(!isCurrentTenure) // For past tenures
      setStatusColumn(isCurrentTenure) // For current tenure
      setShowPreviousRatingColumn(isCurrentTenure) // For current tenure
    }
  }, [rubric])

  const columns = [
    {
      title: (
        <span className="table-title">
          {CommonConstants.columnTitles.indicatorNumber}
        </span>
      ),
      dataIndex: "index",
      key: "index",
      align: "center",
      render: (value) => <span>{value || "N/A"}</span>,
    },
    {
      title: (
        <span className="table-title">
          {CommonConstants.columnTitles.indicator}
        </span>
      ),
      dataIndex: "indicator",
      key: "indicator",
      align: "left",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          style={{ fontSize: "12px", textDecoration: "none" }}
        />
      ),
    },

    showInitialValueColumn && {
      title: (
        <span className="table-title">
          {CommonConstants.columnTitles.initialValue}
        </span>
      ),
      dataIndex: "initial_value",
      key: "initial_value",
      align: "center",
      render: (value) => <span>{value !== null ? value : "N/A"}</span>,
    },

    showPreviousRatingColumn && {
      title: (
        <span className="table-title">
          {CommonConstants.columnTitles.previousRating}
        </span>
      ),
      dataIndex: "previous_rating",
      key: "previous_rating",
      align: "center",
      render: (value) => <span>{value !== null ? value : "N/A"}</span>,
    },
    {
      title: (
        <span className="table-title">
          {CommonConstants.columnTitles.currentValue}
        </span>
      ),
      dataIndex: "current_value",
      key: "current_value",
      align: "center",
      render: (value) => <span>{value !== null ? value : "N/A"}</span>,
    },

    showStatusgColumn && {
      title: (
        <span className="table-title">
          {CommonConstants.columnTitles.status}
        </span>
      ),
      key: "status",
      align: "center",
      render: (_, record) => {
        const {
          previous_rating: previousRating,
          current_value: currentValue,
          goal,
        } = record
        if (goal !== null && currentValue === goal) {
          return (
            <span style={{ color: "#00a65a", fontWeight: 500 }}>
              <img
                src={tickCircle}
                alt="Completed"
                style={{ width: 23, marginRight: 6 }}
              />
              {commonStrings.completed}
            </span>
          )
        }
        if (previousRating !== null && previousRating > currentValue) {
          return (
            <span style={{ color: "#1890ff", fontWeight: 500 }}>
              <img
                src={Frame}
                alt="In Progress"
                style={{ width: 23, marginRight: 6 }}
              />
              {commonStrings.inProgress}
            </span>
          )
        }
        if (previousRating !== null && previousRating < currentValue) {
          return (
            <span style={{ color: "#1890ff", fontWeight: 500 }}>
              <img
                src={path}
                alt="In Progress"
                style={{ width: 23, marginRight: 6 }}
              />
              {commonStrings.inProgress}
            </span>
          )
        }
        return <span style={{ fontWeight: 500 }}>N/A</span>
      },
    },
    disableOnTenureCompletion
      ? {}
      : {
        title: (
          <span className="table-title">
            {CommonConstants.columnTitles.actions}
          </span>
        ),
        key: "actions",
        align: "center",
        render: (_, record) => {
          const isDisabled = record.current_value === null
          const tooltipMessage = "Editing is disabled because the rating has been removed"

          const editButton = (
            <Button
              disabled={isDisabled}
              className="edit-button-title"
              type="link"
              icon={<EditOutlined />}
              onClick={() => handleEditClick(record)}
            >
              Edit
            </Button>
          )

          return isDisabled ? (
            <Tooltip
              overlayInnerStyle={componentStyles.editDisabledTooltip}
              title={<div className="edit-disabled">{tooltipMessage}</div>}
            >
              {editButton}
            </Tooltip>
          ) : (
            editButton
          )
        },
      },
  ].filter(Boolean)

  return (
    <div className="main-indicators-progress">
      <div className="title-set-button">
        <span
          style={{
            alignSelf: "stretch",
            color: "#575555",
            fontSize: 36,
            fontWeight: "600",
          }}
        >
          {commonStrings.indicatorsProgress}
        </span>
        {!disableOnTenureCompletion && (
          <div>
            <button
              className="set-new-goal-title"
              onClick={() => setIsModalVisible(true)}
            >
              <div>
                <span>{commonStrings.setNewGoal}</span>
              </div>
            </button>
          </div>
        )}
      </div>
      <Table
        columns={columns.filter((obj) => Object.keys(obj).length !== 0)}
        dataSource={mergedData.length > 0 ? mergedData : mergedDataold}
        pagination={false}
        rowClassName={(record, index) => (index % 2 === 0 ? "striped-row" : "white-row")}
        bordered
      />

      {isModalVisible && (
        <SetIndicatorGoalModal
          isVisible={isModalVisible}
          onClose={handleCloseModal}
          indicatorData={selectedIndicator}
          tableData={tableData}
          upsertGoals={upsertGoals}
          onSaveGoal={(goals) => {
            if (onUpdatedTableData) {
              onUpdatedTableData(goals)
            }
          }}
          dataSource={mergedData.length > 0 ? mergedData : mergedDataold}
          tableListing={tableListing}
          tableListingold={tableListingold}
          isEditMode={selectedIndicator}
        />
      )}
    </div>
  )
}

export default IndicatorTable
